// removed by extract-text-webpack-plugin
module.exports = {"button":"_1e8bRzDIkhgJd4TuSniXRk","icon":"Mi7WriDGOdTXJlPdTHH36","label":"FrIzYbRkFjsNYEFuS9hr0","default":"_2QJduTIcCH784bI8OcdSuT","flat":"_39vys70tWYAVkTByk7B2if","full":"_22mwfzG6vuNC11zp9dBs-S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/buttons/squareButton/squareButton.css
// module id = 493
// module chunks = 0